<template>
    <div class="sorting_table">
        <div class="lk-popup add_form" v-if="button === 'edit'" style="position: fixed;left: 0;right: 0;top: 12%;z-index: 999;height: auto" >
            <div class="title">
                <h1 style="display: inline-block;"  v-if="!currentProduct.id">Добавить блюдо</h1>
                <h1 style="display: inline-block;"  v-else>Редактирование блюда</h1>
                <button class="cross" @click="button = null, currentProduct = {}" style="background: none;border: 0; float: right"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/referals/cross.svg" alt=""></button>
            </div>
            <div class="content_box">
                <div class="tags_box">
                    <span :class="type==='standart'?'tag active':'tag'" @click="type='standart'">СТАНДАРТНОЕ БЛЮДО</span>
                    <span :class="type==='lunch'?'tag active':'tag'" @click="type='lunch'">ЛАНЧ</span>
                    <span :class="type==='fill'?'tag active':'tag'" @click="type='fill'">НАЧИНКИ</span>
                    <span :class="type==='cake'?'tag active':'tag'" @click="type='cake'">ТОРТЫ НА ЗАКАЗ</span>
                    <span :class="type==='subs'?'tag active':'tag'" @click="type='subs'">ЕДА ПО ПОДПИСКЕ</span>
                    <span :class="type==='program'?'tag active':'tag'" @click="type='program'">ПРОГРАММЫ</span>
                    <span :class="type==='health'?'tag active':'tag'" @click="type='health'">ЗДОРОВОЕ ПИТАНИЕ</span>
                    <span :class="type==='pizzaIng'?'tag active':'tag'" @click="type='pizzaIng'">КОНСТРУКТОР ПИЦЦЫ: ИНГРИДИЕНТЫ</span>
                    <span :class="type==='pizzaSize'?'tag active':'tag'" @click="type='pizzaSize'">КОНСТРУКТОР ПИЦЦЫ: РАЗМЕР</span>
                    <span :class="type==='wokIng'?'tag active':'tag'" @click="type='wokIng'">КОНСТРУКТОР WOK: ИНГРИДИЕНТЫ</span>
                    <span :class="type==='wokSize'?'tag active':'tag'" @click="type='wokSize'">КОНСТРУКТОР WOK: ОСНОВА</span>
                    <!--
                        <span :class="type==='standart'?'tag active':'tag'" @click="type='standart'">СТАНДАРТНОЕ БЛЮДО</span>
                        <span :class="type==='pizzaIng'?'tag active':'tag'" @click="type='pizzaIng'">КОНСТРУКТОР ПИЦЦЫ: ИНГРИДИЕНТЫ</span>
                        <span :class="type==='pizzaSize'?'tag active':'tag'" @click="type='pizzaSize'">КОНСТРУКТОР ПИЦЦЫ: РАЗМЕР</span>
                        <span :class="type==='health'?'tag active':'tag'" @click="type='health'">ЗДОРОВОЕ ПИТАНИЕ</span>
                        <span :class="type==='box'?'tag active':'tag'" @click="type='box'">ЕДА В КОРОБКАХ</span>
                        <span :class="type==='program'?'tag active':'tag'" @click="type='program'">ПРОГРАММЫ</span>
                    -->
                </div>
                <div v-if="type === 'standart'" class="dish_form">

                    <div class="top_part">
                        <div class="info_row file">
                            <span class="input_description">Фото</span>
                            <input class="file_input" id="file_avatar" name="file_avatar" type="file" ref="file" v-on:change="handleFileUpload()">
                            <label for="file_avatar" :style="{backgroundSize: '100% auto', backgroundRepeat: 'no-repeat', backgroundImage: 'url(' + currentProduct.photo + ')'}"></label>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Название</span>
                            <input class="max" type="text" placeholder="Введите текст" v-model="currentProduct.name">
                        </div>

                    </div>

                    <div class="middle_part">

                        <div class="info_row">
                            <span class="input_description">Объём</span>
                            <div class="extra_info">
                                <input type="text" value="0" class="extra" v-model="currentProduct.weight">
                                <select class="select_info extra" v-model="currentProduct.weight_type">
                                    <option v-for="(weight, id) in weights" :key="id" :value="id">{{weight}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Цена, руб</span>
                            <input class="smaller" type="text" value="0" v-model="currentProduct.price">
                            <!--button class="add_btn">+</button-->
                        </div>
                    </div>

                    <div class="bottom_part">

                        <div class="info_row">
                            <span class="input_description">Описание</span>
                            <textarea class="textarea" placeholder="Введите текст" v-model="currentProduct.desc"></textarea>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Иконки</span>
                            <select class="select_info select_icon" multiple v-model="currentProduct.icon">
                                <option v-for="(icon, id) in icons" :key="id" :value="id">{{icon}}</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Тип блюда</span>
                            <select class="select_info select_category" v-model="currentProduct.category_id">
                                <option value="null"></option>
                                <option :value="currentProduct.categorys">{{currentProduct.category}}</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Подкатегория блюда</span>
                            <select class="select_info select_additive" multiple v-model="currentProduct.additive">
                                <option value="null"></option>
                                <option v-for="(additive, id) in currentProduct.additives" :key="id" :value="id">{{additive}}</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Ингридиенты</span>
                            <select class="select_info full select_ingredient" multiple v-model="currentProduct.ingredient">
                                <option value="null"></option>
                                <option v-for="(ingredient, id) in currentProduct.ingredients" :key="id" :value="id">{{ingredient}}</option>
                            </select>
                        </div>

                    </div>

                    <button class="menu_item_btn" @click="saveData(0)">Сохранить</button>
                    <button class="menu_item_btn" v-if="currentIndex" @click="saveData(currentIndex)">Сохранить и открыть следующий</button>

                </div>
                <div v-if="type === 'lunch'" class="dish_form">

                    <div class="bottom_part">

                        <div class="info_row file">
                            <span class="input_description">Фото</span>
                            <input class="file_input" id="file_avatar" name="file_avatar" type="file" ref="file" v-on:change="handleFileUpload()">
                            <label for="file_avatar" :style="{backgroundSize: '100% auto', backgroundRepeat: 'no-repeat', backgroundImage: 'url(' + currentProduct.photo + ')'}"></label>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Название</span>
                            <input class="max" type="text" placeholder="Введите текст" v-model="currentProduct.name">
                        </div>

                        <div class="info_row">
                            <span class="input_description">Объём</span>
                            <div class="extra_info">
                                <input type="number" min="0" class="extra" v-model="currentProduct.weight">
                                <select class="select_info extra" v-model="currentProduct.weight_type">
                                    <option v-for="(weight, id) in weights" :key="id" :value="id">{{weight}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Тип блюда</span>
                            <select class="select_info select_param1" multiple v-model="currentProduct.param1">
                                <option value="Завтрак">Завтрак</option>
                                <option value="Обед">Обед</option>
                                <option value="Ужин">Ужин</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span class="input_description">День недели</span>
                            <select class="select_info select_param2" multiple v-model="currentProduct.param2">
                                <option value="Пн">Понедельник</option>
                                <option value="Вт">Вторник</option>
                                <option value="Ср">Среда</option>
                                <option value="Чт">Четверг</option>
                                <option value="Пт">Пятница</option>
                                <option value="Сб">Суббота</option>
                                <option value="Вс">Воскресенье</option>
                            </select>
                        </div>
                        <div class="info_row">
                            <span class="input_description">Цена, руб</span>
                            <input class="max" type="number" min="0" v-model="currentProduct.price">
                            <!--button class="add_btn">+</button-->
                        </div>
                        <div class="info_row">
                            <span class="input_description">Описание</span>
                            <textarea class="textarea" placeholder="Введите текст" v-model="currentProduct.desc"></textarea>
                        </div>
                    </div>

                    <button class="menu_item_btn" @click="saveLunch(0)">Сохранить</button>
                    <button class="menu_item_btn" v-if="currentIndex" @click="saveLunch(currentIndex)">Сохранить и открыть следующий</button>

                </div>
                <div v-if="type === 'subs'" class="dish_form">

                    <div class="bottom_part">

                        <div class="info_row file">
                            <span class="input_description">Фото</span>
                            <input class="file_input" id="file_avatar" name="file_avatar" type="file" ref="file" v-on:change="handleFileUpload()">
                            <label for="file_avatar" :style="{backgroundSize: '100% auto', backgroundRepeat: 'no-repeat', backgroundImage: 'url(' + currentProduct.photo + ')'}"></label>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Название</span>
                            <input class="max" type="text" placeholder="Введите текст" v-model="currentProduct.name">
                        </div>

                        <div class="info_row">
                            <span class="input_description">Объём</span>
                            <div class="extra_info">
                                <input type="number" min="0" class="extra" v-model="currentProduct.weight">
                                <select class="select_info extra" v-model="currentProduct.weight_type">
                                    <option v-for="(weight, id) in weights" :key="id" :value="id">{{weight}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Тип блюда</span>
                            <select class="select_info select_param1" multiple v-model="currentProduct.param1">
                                <option value="Завтрак">Завтрак</option>
                                <option value="Обед">Обед</option>
                                <option value="Ужин">Ужин</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span class="input_description">День недели</span>
                            <select class="select_info select_param2" multiple v-model="currentProduct.param2">
                                <option value="Пн">Понедельник</option>
                                <option value="Вт">Вторник</option>
                                <option value="Ср">Среда</option>
                                <option value="Чт">Четверг</option>
                                <option value="Пт">Пятница</option>
                                <option value="Сб">Суббота</option>
                                <option value="Вс">Воскресенье</option>
                            </select>
                        </div>
                        <div class="info_row">
                            <span class="input_description">Цена, руб</span>
                            <input class="max" type="number" min="0" v-model="currentProduct.price">
                            <!--button class="add_btn">+</button-->
                        </div>
                        <div class="info_row">
                            <span class="input_description">Описание</span>
                            <textarea class="textarea" placeholder="Введите текст" v-model="currentProduct.desc"></textarea>
                        </div>
                    </div>

                    <button class="menu_item_btn" @click="saveSubs(0)">Сохранить</button>
                    <button class="menu_item_btn" v-if="currentIndex" @click="saveSubs(currentIndex)">Сохранить и открыть следующий</button>

                </div>
                <div v-if="type === 'pizzaIng'" class="dish_form">

                    <div class="top_part">

                        <div class="info_row">
                            <span class="input_description">Подкатегория</span>
                            <select class="select_info select_additive" v-model="currentProduct.param1">
                                <option v-for="(additive, id) in currentProduct.params1" :key="id" :value="id.toString()">{{additive}}</option>
                            </select>
                        </div>

                    </div>

                    <div class="bottom_part">

                        <div class="info_row">
                            <span class="input_description">Ингридиент</span>
                            <select class="select_info full select_ingredient" v-model="currentProduct.param2">
                                <option v-for="(ingredient, id) in currentProduct.params2" :key="id" :value="id.toString()">{{ingredient}}</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Цена, руб</span>
                            <input class="max" type="number" min="0" v-model="currentProduct.price">
                        </div>
                    </div>

                    <button class="menu_item_btn" @click="savePizzaIng(0)">Сохранить</button>
                    <button class="menu_item_btn" v-if="currentIndex" @click="savePizzaIng(currentIndex)">Сохранить и открыть следующий</button>

                </div>
                <div v-if="type === 'pizzaSize'" class="dish_form">

                    <div class="bottom_part">

                        <div class="info_row">
                            <span class="input_description">Основа</span>
                            <select class="select_info full select_main" v-model="currentProduct.param1">
                                <option v-for="(ingredient, id) in currentProduct.params1" :key="id" :value="id.toString()">{{ingredient}}</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Размер</span>
                            <select class="select_info full select_size" v-model="currentProduct.param2">
                                <option v-for="(ingredient, id) in currentProduct.params2" :key="id" :value="id.toString()">{{ingredient}}</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Цена, руб</span>
                            <input class="max" type="number" min="0" v-model="currentProduct.price">
                        </div>
                    </div>

                    <button class="menu_item_btn" @click="savePizzaSize(0)">Сохранить</button>
                    <button class="menu_item_btn" v-if="currentIndex" @click="savePizzaSize(currentIndex)">Сохранить и открыть следующий</button>

                </div>
                <div v-if="type === 'wokIng'" class="dish_form">

                    <div class="top_part">

                        <div class="info_row">
                            <span class="input_description">Подкатегория</span>
                            <select class="select_info select_additive" v-model="currentProduct.param1">
                                <option v-for="(additive, id) in currentProduct.params1" :key="id" :value="id.toString()">{{additive}}</option>
                            </select>
                        </div>

                    </div>

                    <div class="bottom_part">

                        <div class="info_row">
                            <span class="input_description">Ингридиент</span>
                            <select class="select_info full select_ingredient" v-model="currentProduct.param2">
                                <option v-for="(ingredient, id) in currentProduct.params2" :key="id" :value="id.toString()">{{ingredient}}</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Цена, руб</span>
                            <input class="max" type="number" min="0" v-model="currentProduct.price">
                        </div>
                    </div>

                    <button class="menu_item_btn" @click="saveWokIng(0)">Сохранить</button>
                    <button class="menu_item_btn" v-if="currentIndex" @click="saveWokIng(currentIndex)">Сохранить и открыть следующий</button>

                </div>
                <div v-if="type === 'wokSize'" class="dish_form">

                    <div class="bottom_part">

                        <div class="info_row">
                            <span class="input_description">Основа</span>
                            <select class="select_info full select_main" v-model="currentProduct.param1">
                                <option v-for="(ingredient, id) in currentProduct.params1" :key="id" :value="id.toString()">{{ingredient}}</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Цена, руб</span>
                            <input class="max" type="number" min="0" v-model="currentProduct.price">
                        </div>
                    </div>

                    <button class="menu_item_btn" @click="saveWokSize(0)">Сохранить</button>
                    <button class="menu_item_btn" v-if="currentIndex" @click="saveWokSize(currentIndex)">Сохранить и открыть следующий</button>

                </div>
                <div v-if="type === 'health'" class="dish_form">

                    <div class="bottom_part">

                        <div class="info_row file">
                            <span class="input_description">Фото</span>
                            <input class="file_input" id="file_avatar" name="file_avatar" type="file" ref="file" v-on:change="handleFileUpload()">
                            <label for="file_avatar" :style="{backgroundSize: '100% auto', backgroundRepeat: 'no-repeat', backgroundImage: 'url(' + currentProduct.photo + ')'}"></label>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Название</span>
                            <input class="max" type="text" placeholder="Введите текст" v-model="currentProduct.name">
                        </div>

                        <div class="info_row">
                            <span class="input_description">Программа</span>
                            <select class="select_info select_param3" multiple v-model="currentProduct.param3">
                                <option v-if="currentProduct.params3" v-for="(pV, pK) in currentProduct.params3" :value="pK" :key="pK">{{pV}}</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Неделя</span>
                            <select class="select_info select_param1" multiple v-model="currentProduct.param1">
                                <option value="1">1</option>
                                <option value="2">2</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span class="input_description">День недели</span>
                            <select class="select_info select_param2" multiple v-model="currentProduct.param2">
                                <option value="Пн">Понедельник</option>
                                <option value="Вт">Вторник</option>
                                <option value="Ср">Среда</option>
                                <option value="Чт">Четверг</option>
                                <option value="Пт">Пятница</option>
                                <option value="Сб">Суббота</option>
                                <option value="Вс">Воскресенье</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Описание</span>
                            <textarea class="textarea" placeholder="Введите текст" v-model="currentProduct.desc"></textarea>
                        </div>

                    </div>

                    <button class="menu_item_btn" @click="saveHealth(0)">Сохранить</button>
                    <button class="menu_item_btn" v-if="currentIndex" @click="saveHealth(currentIndex)">Сохранить и открыть следующий</button>

                </div>
                <div v-if="type === 'box'" class="dish_form">

                    <div class="bottom_part">

                        <div class="info_row file">
                            <span class="input_description">Фото</span>
                            <input class="file_input" name="file_avatar" type="file">
                            <label for="file_avatar"></label>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Название</span>
                            <input class="max" type="text" placeholder="Введите текст">
                        </div>

                        <div class="info_row">
                            <span class="input_description">Вес, грамм</span>
                            <input class="extra" type="text" value="0">
                        </div>

                        <div class="info_row">
                            <span class="input_description">Тип блюда</span>
                            <select class="select_info" name="amount">
                                <option value="1">Завтрак</option>
                                <option value="2">Такой</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span class="input_description">День недели</span>
                            <select class="select_info" name="amount">
                                <option value="1">Понедельник</option>
                                <option value="2">Такой</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Тип блюда</span>
                            <input type="text" value="0">
                        </div>

                        <div class="info_row">
                            <span class="input_description">Подкатегория блюда</span>
                            <select class="select_info" name="amount">
                                <option value="1">Горячие роллы</option>
                                <option value="2">Такой</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Ингрдиенты</span>
                            <textarea class="textarea full" placeholder="Введите текст"></textarea>
                        </div>

                    </div>

                    <button class="menu_item_btn">Сохранить</button>

                </div>
                <div v-if="type === 'fill'" class="dish_form">

                    <div class="bottom_part">
                        <div class="info_row file">
                            <span class="input_description">Фото</span>
                            <input class="file_input" id="file_avatar" name="file_avatar" type="file" ref="file" v-on:change="handleFileUpload()">
                            <label for="file_avatar" :style="{backgroundSize: '100% auto', backgroundRepeat: 'no-repeat', backgroundImage: 'url(' + currentProduct.photo + ')'}"></label>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Название</span>
                            <input class="max" type="text" placeholder="Введите текст" v-model="currentProduct.name">
                        </div>

                        <div class="info_row">
                            <span class="input_description">Цена, руб</span>
                            <input class="max" type="number" min="0" v-model="currentProduct.price">
                        </div>

                        <div class="info_row">
                            <span class="input_description">Описание</span>
                            <textarea class="textarea full" placeholder="Введите текст" v-model="currentProduct.desc"></textarea>
                        </div>

                    </div>

                    <button class="menu_item_btn" @click="saveFill(0)">Сохранить</button>
                    <button class="menu_item_btn" v-if="currentIndex" @click="saveFill(currentIndex)">Сохранить и открыть следующий</button>

                </div>
                <div v-if="type === 'cake'" class="dish_form">

                    <div class="bottom_part">

                        <div class="info_row file">
                            <span class="input_description">Фото</span>
                            <input class="file_input" id="file_avatar" name="file_avatar" type="file" ref="file" v-on:change="handleFileUpload()">
                            <label for="file_avatar" :style="{backgroundSize: '100% auto', backgroundRepeat: 'no-repeat', backgroundImage: 'url(' + currentProduct.photo + ')'}"></label>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Название</span>
                            <input class="max" type="text" placeholder="Введите текст" v-model="currentProduct.name">
                        </div>

                        <div class="info_row">
                            <span class="input_description">Минимальный вес, кг</span>
                            <input class="max" type="number" min="0"  v-model="currentProduct.param1">
                        </div>

                        <div class="info_row">
                            <span class="input_description">Цена за кг, руб</span>
                            <input class="max" type="number" min="0" v-model="currentProduct.price">
                        </div>

                        <div class="info_row">
                            <span class="input_description">Описание</span>
                            <textarea class="textarea full" placeholder="Введите текст" v-model="currentProduct.desc"></textarea>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Категория торта</span>
                            <select class="select_info full select_ingredient" multiple v-model="currentProduct.ingredient">
                                <option v-for="(ingredient, id) in currentProduct.ingredients" :key="id" :value="id">{{ingredient}}</option>
                            </select>
                        </div>

                    </div>

                    <button class="menu_item_btn" @click="saveCake(0)">Сохранить</button>
                    <button class="menu_item_btn" v-if="currentIndex" @click="saveCake(currentIndex)">Сохранить и открыть следующий</button>

                </div>
                <div v-if="type === 'program'" class="dish_form">

                    <div class="bottom_part">

                        <div class="info_row file">
                            <span class="input_description">Фото</span>
                            <input class="file_input" id="file_avatar" name="file_avatar" type="file" ref="file" v-on:change="handleFileUpload()">
                            <label for="file_avatar" :style="{backgroundSize: '100% auto', backgroundRepeat: 'no-repeat', backgroundImage: 'url(' + currentProduct.photo + ')'}"></label>
                        </div>

                        <div class="info_row">
                            <span class="input_description">Название</span>
                            <input class="max" type="text" placeholder="Введите текст" v-model="currentProduct.name">
                        </div>

                        <div class="info_row">
                            <span class="input_description">Цена, руб</span>
                            <input class="max" type="number" min="0" v-model="currentProduct.price">
                            <!--button class="add_btn">+</button-->
                        </div>

                        <div class="info_row">
                            <span class="input_description">Тип программы</span>
                            <select class="select_info select_additive" multiple v-model="currentProduct.additive">
                                <option v-for="(additive, id) in currentProduct.additives" :key="id" :value="id">{{additive}}</option>
                            </select>
                        </div>
                        <div class="info_row">
                            <span class="input_description">Описание</span>
                            <textarea class="textarea" placeholder="Введите текст" v-model="currentProduct.desc"></textarea>
                        </div>

                    </div>

                    <button class="menu_item_btn" @click="saveProgram(0)">Сохранить</button>
                    <button class="menu_item_btn" v-if="currentIndex" @click="saveProgram(currentIndex)">Сохранить и открыть следующий</button>

                </div>
            </div>
        </div>
        <div class="toolbar">
          <button @click="button = 'edit', currentIndex = null, type = 'standart'">Добавить</button>
        </div>
        <table class="menu_table" id="menu_table">
            <thead>
            <tr class="row">
                <th>Фото</th>
                <th>Название</th>
                <th>Тип блюда</th>
                <th>Объем</th>
                <th>Цена, руб</th>
                <th>Включен</th>
                <th>Обновлён</th>
                <th></th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr class="row" v-for="(product, index) in products" :key="index" v-show="product.show">
                <td class="td">
                    <img v-if="product.photo" :src="product.photo" alt="">
                </td>
                <td class="td">{{product.name}}</td>
                <td class="td">{{product.category}}</td>
                <td class="td" v-if="product.weight">{{product.weight}} {{weights[product.weight_type]}}</td>
                <td class="td" v-else></td>
                <td class="td">{{product.price}}</td>
                <td class="td">
                    <span class="dish_including" v-if="product.status === 'да'" @click="product.status='нет', saveStatus(product.id, 0)" style="background: #00ff1cd4;padding: 2px 5px;border-radius: 8px;color: black;cursor: pointer;">{{product.status}}</span>
                    <span class="dish_including" v-else @click="product.status='да', saveStatus(product.id, 1)" style="background: #ff0000d4;padding: 2px 5px;border-radius: 8px;color: white;cursor: pointer;">{{product.status}}</span>
                </td>
                <td class="td">{{product.updated_at?product.updated_at:product.created_at}}</td>
                <td class="td">
                    <button class="button edit" @click="(currentProduct = product, currentIndex = index, button = 'edit')">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lk/edit.svg" alt="">
                    </button>
                </td>
                <td class="td">
                    <button class="button cancel" @click="deleteProduct(product, index)">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lk/cancel.svg" alt="">
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'
import 'datatables'
import 'datatables/media/css/jquery.dataTables.css'
import 'select2/dist/css/select2.min.css'
import 'select2'
export default {
  name: 'menus',
  props: ['auth', 'id', 'mapinit', 'user'],
  data () {
    return {
      products: [],
      button: null,
      currentProduct: {},
      currentIndex: null,
      type: 'standart',
      table: null,
      file: null,
      restaurant: {},
      weights: {
        1: 'г.',
        2: 'мл.',
        3: 'л.',
        4: 'шт.',
        5: 'см.',
        6: 'порц.'
      },
      icons: {
        'good': 'Правильное питание',
        'hot': 'Острое',
        'vegan': 'Вегетарианское меню',
        'baby': 'Детское меню',
        'fursh': 'Фуршетное меню'
      }
    }
  },
  created () {
    if (this.auth.uid) this.loadRest()
    else {
      setTimeout(() => {
        if (this.auth.uid) this.loadRest()
      }, 100)
    }
  },
  methods: {
    saveStatus (product, status) {
      var formData = new FormData()
      formData.append('id', product)
      formData.append('status', status)
      axios.post('https://lk.when-hungry.com/mobile/save-status-product',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
    },
    deleteProduct (product, index) {
      if (confirm('Вы действительно хотите удалить эту позицию?')) {
        var formData = new FormData()
        formData.append('id', this.id)
        formData.append('uid', this.$root.auth.uid)
        formData.append('product_id', product.id)
        axios.post('https://lk.when-hungry.com/mobile/delete-product',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(() => {
          // this.table.destroy()
          this.products[index].show = false
          setTimeout(() => {
            alert('позиция меню удалена')
          }, 1)
        })
      }
    },
    handleFileUpload () {
      var reader = new FileReader()
      reader.onload = (e) => {
        $('label[for="file_avatar"]').css('background-image', `url(${e.target.result})`)
        this.file = e.target.result
      }
      reader.readAsDataURL(this.$refs.file.files[0])
    },
    saveData (id) {
      console.log(JSON.parse(JSON.stringify(this.currentProduct)))
      this.currentProduct.restaurant_id = this.restaurant.id
      this.currentProduct.restaurant_name = this.restaurant.name
      var formData = new FormData()
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('product', JSON.stringify(this.currentProduct))
      if (this.file !== null) formData.append('photos', this.file)
      axios.post('https://lk.when-hungry.com/mobile/save-product',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        if (response.data.status === 'error') {
          alert(response.data.text)
        } else {
          // this.table.destroy()
          // this.loadRest()
          if (!id) {
            setTimeout(() => {
              alert('Изменения сохранены')
            }, 1)
          }
          this.currentProduct = {}
          this.button = null
          this.type = 'standart'
          if (id && this.products[id + 1] !== undefined) {
            this.currentProduct = this.products[id + 1]
            this.currentIndex = id + 1
            this.button = 'edit'
          }
        }
      })
    },
    saveLunch (id) {
      console.log(JSON.parse(JSON.stringify(this.currentProduct)))
      this.currentProduct.restaurant_id = this.restaurant.id
      this.currentProduct.restaurant_name = this.restaurant.name
      this.currentProduct.category_id = 9
      this.currentProduct.type = 'lunch'
      var formData = new FormData()
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('product', JSON.stringify(this.currentProduct))
      if (this.file !== null) formData.append('photos', this.file)
      axios.post('https://lk.when-hungry.com/mobile/save-product',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        if (response.data.status === 'error') {
          alert(response.data.text)
        } else {
          // this.table.destroy()
          // this.loadRest()
          if (!id) {
            setTimeout(() => {
              alert('Изменения сохранены')
            }, 1)
          }
          this.currentProduct = {}
          this.button = null
          this.type = 'standart'
          if (id && this.products[id + 1] !== undefined) {
            this.currentProduct = this.products[id + 1]
            this.currentIndex = id + 1
            this.button = 'edit'
          }
        }
      })
    },
    saveSubs (id) {
      console.log(JSON.parse(JSON.stringify(this.currentProduct)))
      this.currentProduct.restaurant_id = this.restaurant.id
      this.currentProduct.restaurant_name = this.restaurant.name
      this.currentProduct.category_id = 29
      this.currentProduct.type = 'subs'
      var formData = new FormData()
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('product', JSON.stringify(this.currentProduct))
      if (this.file !== null) formData.append('photos', this.file)
      axios.post('https://lk.when-hungry.com/mobile/save-product',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        if (response.data.status === 'error') {
          alert(response.data.text)
        } else {
          // this.table.destroy()
          // this.loadRest()
          if (!id) {
            setTimeout(() => {
              alert('Изменения сохранены')
            }, 1)
          }
          this.currentProduct = {}
          this.button = null
          this.type = 'standart'
          if (id && this.products[id + 1] !== undefined) {
            this.currentProduct = this.products[id + 1]
            this.currentIndex = id + 1
            this.button = 'edit'
          }
        }
      })
    },
    saveHealth (id) {
      if (!this.currentProduct.param3) {
        alert('Вам необходимо указать хоть 1 программу')
      } else {
        console.log(JSON.parse(JSON.stringify(this.currentProduct)))
        this.currentProduct.restaurant_id = this.restaurant.id
        this.currentProduct.restaurant_name = this.restaurant.name
        this.currentProduct.category_id = 21
        this.currentProduct.type = 'health'
        var formData = new FormData()
        formData.append('id', this.id)
        formData.append('uid', this.$root.auth.uid)
        formData.append('product', JSON.stringify(this.currentProduct))
        if (this.file !== null) formData.append('photos', this.file)
        axios.post('https://lk.when-hungry.com/mobile/save-product',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then((response) => {
          if (response.data.status === 'error') {
            alert(response.data.text)
          } else {
            // this.table.destroy()
            // this.loadRest()
            if (!id) {
              setTimeout(() => {
                alert('Изменения сохранены')
              }, 1)
            }
            this.currentProduct = {}
            this.button = null
            this.type = 'standart'
            if (id && this.products[id + 1] !== undefined) {
              this.currentProduct = this.products[id + 1]
              this.currentIndex = id + 1
              this.button = 'edit'
            }
          }
        })
      }
    },
    saveProgram (id) {
      console.log(JSON.parse(JSON.stringify(this.currentProduct)))
      this.currentProduct.restaurant_id = this.restaurant.id
      this.currentProduct.restaurant_name = this.restaurant.name
      this.currentProduct.category_id = 21
      this.currentProduct.type = 'program'
      var formData = new FormData()
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('product', JSON.stringify(this.currentProduct))
      if (this.file !== null) formData.append('photos', this.file)
      axios.post('https://lk.when-hungry.com/mobile/save-product',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        if (response.data.status === 'error') {
          alert(response.data.text)
        } else {
          // this.table.destroy()
          // this.loadRest()
          if (!id) {
            setTimeout(() => {
              alert('Изменения сохранены')
            }, 1)
          }
          this.currentProduct = {}
          this.button = null
          this.type = 'standart'
          if (id && this.products[id + 1] !== undefined) {
            this.currentProduct = this.products[id + 1]
            this.currentIndex = id + 1
            this.button = 'edit'
          }
        }
      })
    },
    saveCake (id) {
      console.log(JSON.parse(JSON.stringify(this.currentProduct)))
      this.currentProduct.restaurant_id = this.restaurant.id
      this.currentProduct.restaurant_name = this.restaurant.name
      this.currentProduct.category_id = 15
      this.currentProduct.additive = [47]
      this.currentProduct.type = 'cake'
      var formData = new FormData()
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('product', JSON.stringify(this.currentProduct))
      if (this.file !== null) formData.append('photos', this.file)
      axios.post('https://lk.when-hungry.com/mobile/save-product',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        if (response.data.status === 'error') {
          alert(response.data.text)
        } else {
          // this.table.destroy()
          // this.loadRest()
          if (!id) {
            setTimeout(() => {
              alert('Изменения сохранены')
            }, 1)
          }
          this.currentProduct = {}
          this.button = null
          this.type = 'standart'
          if (id && this.products[id + 1] !== undefined) {
            this.currentProduct = this.products[id + 1]
            this.currentIndex = id + 1
            this.button = 'edit'
          }
        }
      })
    },
    saveFill (id) {
      console.log(JSON.parse(JSON.stringify(this.currentProduct)))
      this.currentProduct.restaurant_id = this.restaurant.id
      this.currentProduct.restaurant_name = this.restaurant.name
      this.currentProduct.category_id = 15
      this.currentProduct.additive = [67]
      this.currentProduct.type = 'fill'
      var formData = new FormData()
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('product', JSON.stringify(this.currentProduct))
      if (this.file !== null) formData.append('photos', this.file)
      axios.post('https://lk.when-hungry.com/mobile/save-product',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        if (response.data.status === 'error') {
          alert(response.data.text)
        } else {
          // this.table.destroy()
          // this.loadRest()
          if (!id) {
            setTimeout(() => {
              alert('Изменения сохранены')
            }, 1)
          }
          this.currentProduct = {}
          this.button = null
          this.type = 'standart'
          if (id && this.products[id + 1] !== undefined) {
            this.currentProduct = this.products[id + 1]
            this.currentIndex = id + 1
            this.button = 'edit'
          }
        }
      })
    },
    savePizzaIng (id) {
      console.log(JSON.parse(JSON.stringify(this.currentProduct)))
      this.currentProduct.restaurant_id = this.restaurant.id
      this.currentProduct.restaurant_name = this.restaurant.name
      this.currentProduct.category_id = 2
      this.currentProduct.name = 'Начинка в пиццу'
      this.currentProduct.additive = [this.currentProduct.param1]
      this.currentProduct.ingredient = [this.currentProduct.param2]
      this.currentProduct.type = 'pizzaIng'
      var formData = new FormData()
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('product', JSON.stringify(this.currentProduct))
      axios.post('https://lk.when-hungry.com/mobile/save-product',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        if (response.data.status === 'error') {
          alert(response.data.text)
        } else {
          // this.table.destroy()
          // this.loadRest()
          if (!id) {
            setTimeout(() => {
              alert('Изменения сохранены')
            }, 1)
          }
          this.currentProduct = {}
          this.button = null
          this.type = 'standart'
          if (id && this.products[id + 1] !== undefined) {
            this.currentProduct = this.products[id + 1]
            this.currentIndex = id + 1
            this.button = 'edit'
          }
        }
      })
    },
    savePizzaSize (id) {
      console.log(JSON.parse(JSON.stringify(this.currentProduct)))
      this.currentProduct.restaurant_id = this.restaurant.id
      this.currentProduct.restaurant_name = this.restaurant.name
      this.currentProduct.category_id = 2
      this.currentProduct.name = 'Основа в пиццу'
      this.currentProduct.additive = [124, 125]
      this.currentProduct.ingredient = [this.currentProduct.param1, this.currentProduct.param2]
      this.currentProduct.type = 'pizzaSize'
      var formData = new FormData()
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('product', JSON.stringify(this.currentProduct))
      axios.post('https://lk.when-hungry.com/mobile/save-product',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        if (response.data.status === 'error') {
          alert(response.data.text)
        } else {
          // this.table.destroy()
          // this.loadRest()
          if (!id) {
            setTimeout(() => {
              alert('Изменения сохранены')
            }, 1)
          }
          this.currentProduct = {}
          this.button = null
          this.type = 'standart'
          if (id && this.products[id + 1] !== undefined) {
            this.currentProduct = this.products[id + 1]
            this.currentIndex = id + 1
            this.button = 'edit'
          }
        }
      })
    },
    saveWokIng (id) {
      console.log(JSON.parse(JSON.stringify(this.currentProduct)))
      this.currentProduct.restaurant_id = this.restaurant.id
      this.currentProduct.restaurant_name = this.restaurant.name
      this.currentProduct.category_id = 33
      this.currentProduct.name = 'Начинка в WOK'
      this.currentProduct.additive = [this.currentProduct.param1]
      this.currentProduct.ingredient = [this.currentProduct.param2]
      this.currentProduct.type = 'wokIng'
      var formData = new FormData()
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('product', JSON.stringify(this.currentProduct))
      axios.post('https://lk.when-hungry.com/mobile/save-product',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        if (response.data.status === 'error') {
          alert(response.data.text)
        } else {
          // this.table.destroy()
          // this.loadRest()
          if (!id) {
            setTimeout(() => {
              alert('Изменения сохранены')
            }, 1)
          }
          this.currentProduct = {}
          this.button = null
          this.type = 'standart'
          if (id && this.products[id + 1] !== undefined) {
            this.currentProduct = this.products[id + 1]
            this.currentIndex = id + 1
            this.button = 'edit'
          }
        }
      })
    },
    saveWokSize (id) {
      console.log(JSON.parse(JSON.stringify(this.currentProduct)))
      this.currentProduct.restaurant_id = this.restaurant.id
      this.currentProduct.restaurant_name = this.restaurant.name
      this.currentProduct.category_id = 33
      this.currentProduct.name = 'Основа в WOK'
      this.currentProduct.additive = [123]
      this.currentProduct.ingredient = [this.currentProduct.param1]
      this.currentProduct.type = 'wokSize'
      var formData = new FormData()
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('product', JSON.stringify(this.currentProduct))
      axios.post('https://lk.when-hungry.com/mobile/save-product',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        if (response.data.status === 'error') {
          alert(response.data.text)
        } else {
          // this.table.destroy()
          // this.loadRest()
          if (!id) {
            setTimeout(() => {
              alert('Изменения сохранены')
            }, 1)
          }
          this.currentProduct = {}
          this.button = null
          this.type = 'standart'
          if (id && this.products[id + 1] !== undefined) {
            this.currentProduct = this.products[id + 1]
            this.currentIndex = id + 1
            this.button = 'edit'
          }
        }
      })
    },
    loadRest () {
      axios.get('https://lk.when-hungry.com/mobile/get-products?uid=' + this.auth.uid + '&id=' + this.id).then(response => {
        this.products = response.data.products
        this.restaurant = response.data.restaurant
      })
    },
    renderSelect () {
      let self = this
      if ($('.dish_form span.select2.select2-container').length !== 0) $('.dish_form span.select2.select2-container').remove()
      if (this.type === 'standart') {
        $('.select_category').select2({
          width: '100%',
          ajax: {
            url: 'https://lk.when-hungry.com/mobile/search-category',
            dataType: 'json',
            processResults: function (data) {
              return {
                results: $.map(data, function (key, item) {
                  return {
                    text: key,
                    id: item
                  }
                })
              }
            }
          }
        }).on('select2:select', function () {
          self.currentProduct.category_id = $(this).val()
          self.currentProduct.additive = []
          self.currentProduct.ingredient = []
        })
        $('.select_additive').select2({
          width: '100%',
          ajax: {
            url: 'https://lk.when-hungry.com/mobile/search-additive',
            data: (params) => {
              params.id = this.currentProduct.category_id
              params.q = params.term
              return params
            },
            dataType: 'json',
            processResults: function (data) {
              return {
                results: $.map(data, function (key, item) {
                  return {
                    text: key,
                    id: item
                  }
                })
              }
            }
          }
        }).on('select2:select', function () {
          self.currentProduct.additive = $(this).val()
          self.currentProduct.ingredient = []
        })
        $('.select_ingredient').select2({
          width: '100%',
          ajax: {
            url: 'https://lk.when-hungry.com/mobile/search-ingredient',
            data: (params) => {
              params.id = this.currentProduct.additive
              params.q = params.term
              return params
            },
            dataType: 'json',
            processResults: function (data) {
              return {
                results: $.map(data, function (key, item) {
                  return {
                    text: key,
                    id: item
                  }
                })
              }
            }
          }
        }).on('select2:select', function () {
          self.currentProduct.ingredient = $(this).val()
        })
        $('.select_icon').select2({width: '100%'}).val(this.currentProduct.icon).trigger('change.select2').on('select2:select', function () { self.currentProduct.icon = $(this).val() })
      } else if (this.type === 'lunch' || this.type === 'subs') {
        $('.select_param1').select2({width: '100%'}).val(this.currentProduct.param1).trigger('change.select2').on('select2:select', function () { self.currentProduct.param1 = $(this).val() })
        $('.select_param2').select2({width: '100%'}).val(this.currentProduct.param2).trigger('change.select2').on('select2:select', function () { self.currentProduct.param2 = $(this).val() })
      } else if (this.type === 'cake') {
        $('.select_ingredient').select2({
          width: '100%',
          ajax: {
            url: 'https://lk.when-hungry.com/mobile/search-ingredient',
            data: (params) => {
              params.id = 47
              params.q = params.term
              return params
            },
            dataType: 'json',
            processResults: function (data) {
              return {
                results: $.map(data, function (key, item) {
                  return {
                    text: key,
                    id: item
                  }
                })
              }
            }
          }
        }).on('select2:select', function () {
          self.currentProduct.ingredient = $(this).val()
        })
      } else if (this.type === 'program') {
        $('.select_additive').select2({
          width: '100%',
          ajax: {
            url: 'https://lk.when-hungry.com/mobile/search-additive',
            data: (params) => {
              params.id = 21
              params.q = params.term
              return params
            },
            dataType: 'json',
            processResults: function (data) {
              return {
                results: $.map(data, function (key, item) {
                  return {
                    text: key,
                    id: item
                  }
                })
              }
            }
          }
        }).on('select2:select', function () {
          self.currentProduct.additive = $(this).val()
          self.currentProduct.ingredient = []
        })
      } else if (this.type === 'health') {
        $('.select_param1').select2({width: '100%'}).val(this.currentProduct.param1).trigger('change.select2').on('select2:select', function () { self.currentProduct.param1 = $(this).val() })
        $('.select_param2').select2({width: '100%'}).val(this.currentProduct.param2).trigger('change.select2').on('select2:select', function () { self.currentProduct.param2 = $(this).val() })
        $('.select_param3').select2({
          width: '100%',
          ajax: {
            url: 'https://lk.when-hungry.com/mobile/search-product',
            data: (params) => {
              params.id = this.id
              params.cat = 21
              params.type = 'program'
              params.q = params.term
              return params
            },
            dataType: 'json',
            processResults: function (data) {
              return {
                results: $.map(data, function (key, item) {
                  return {
                    text: key,
                    id: item
                  }
                })
              }
            }
          }
        }).val(this.currentProduct.param3).trigger('change.select2').on('select2:select', function () { self.currentProduct.param3 = $(this).val() })
      } else if (this.type === 'pizzaIng') {
        $('.select_additive').select2({
          width: '100%',
          ajax: {
            url: 'https://lk.when-hungry.com/mobile/search-additive',
            data: (params) => {
              params.id = 2
              params.q = params.term
              return params
            },
            dataType: 'json',
            processResults: function (data) {
              return {
                results: $.map(data, function (key, item) {
                  return {
                    text: key,
                    id: item
                  }
                })
              }
            }
          }
        }).on('select2:select', function () {
          self.currentProduct.param1 = $(this).val()
          self.currentProduct.param2 = []
        })
        $('.select_ingredient').select2({
          width: '100%',
          ajax: {
            url: 'https://lk.when-hungry.com/mobile/search-ingredient',
            data: (params) => {
              params.id = this.currentProduct.param1
              params.q = params.term
              return params
            },
            dataType: 'json',
            processResults: function (data) {
              return {
                results: $.map(data, function (key, item) {
                  return {
                    text: key,
                    id: item
                  }
                })
              }
            }
          }
        }).on('select2:select', function () {
          self.currentProduct.param2 = $(this).val()
        })
      } else if (this.type === 'pizzaSize') {
        $('.select_main').select2({
          width: '100%',
          ajax: {
            url: 'https://lk.when-hungry.com/mobile/search-ingredient',
            data: (params) => {
              params.id = 124
              params.q = params.term
              return params
            },
            dataType: 'json',
            processResults: function (data) {
              return {
                results: $.map(data, function (key, item) {
                  return {
                    text: key,
                    id: item
                  }
                })
              }
            }
          }
        }).on('select2:select', function () {
          self.currentProduct.param1 = $(this).val()
        })
        $('.select_size').select2({
          width: '100%',
          ajax: {
            url: 'https://lk.when-hungry.com/mobile/search-ingredient',
            data: (params) => {
              params.id = 125
              params.q = params.term
              return params
            },
            dataType: 'json',
            processResults: function (data) {
              return {
                results: $.map(data, function (key, item) {
                  return {
                    text: key,
                    id: item
                  }
                })
              }
            }
          }
        }).on('select2:select', function () {
          self.currentProduct.param2 = $(this).val()
        })
      } else if (this.type === 'wokSize') {
        $('.select_main').select2({
          width: '100%',
          ajax: {
            url: 'https://lk.when-hungry.com/mobile/search-ingredient',
            data: (params) => {
              params.id = 123
              params.q = params.term
              return params
            },
            dataType: 'json',
            processResults: function (data) {
              return {
                results: $.map(data, function (key, item) {
                  return {
                    text: key,
                    id: item
                  }
                })
              }
            }
          }
        }).on('select2:select', function () {
          self.currentProduct.param1 = $(this).val()
        })
      } else if (this.type === 'wokIng') {
        $('.select_additive').select2({
          width: '100%',
          ajax: {
            url: 'https://lk.when-hungry.com/mobile/search-additive',
            data: (params) => {
              params.id = 33
              params.q = params.term
              return params
            },
            dataType: 'json',
            processResults: function (data) {
              return {
                results: $.map(data, function (key, item) {
                  return {
                    text: key,
                    id: item
                  }
                })
              }
            }
          }
        }).on('select2:select', function () {
          self.currentProduct.param1 = $(this).val()
          self.currentProduct.param2 = []
        })
        $('.select_ingredient').select2({
          width: '100%',
          ajax: {
            url: 'https://lk.when-hungry.com/mobile/search-ingredient',
            data: (params) => {
              params.id = this.currentProduct.param1
              params.q = params.term
              return params
            },
            dataType: 'json',
            processResults: function (data) {
              return {
                results: $.map(data, function (key, item) {
                  return {
                    text: key,
                    id: item
                  }
                })
              }
            }
          }
        }).on('select2:select', function () {
          self.currentProduct.param2 = $(this).val()
        })
      }
    }
  },
  watch: {
    'button' (val) {
      if (val) {
        setTimeout(() => {
          this.renderSelect()
        }, 1)
      }
    },
    'type' (val) {
      if (val) {
        setTimeout(() => {
          this.renderSelect()
        }, 1)
      }
    },
    id (val, oldVal) {
      if (val !== oldVal) {
        // this.loadRest()
      }
    },
    'currentProduct.category_id' (val, oldVal) {
      // if (val) {
      console.table({
        val: val,
        oldVal: oldVal
      })
      if (val === null && oldVal !== val) this.currentProduct.category_id = 'null'
      $('.select_category').val(this.currentProduct.category_id).trigger('change.select2')
      // }
    },
    'currentProduct.additive' (val, oldVal) {
      if (val) {
        $('.select_additive').val(this.currentProduct.additive).trigger('change.select2')
      }
    },
    'currentProduct.ingredient' (val, oldVal) {
      if (val) {
        $('.select_ingredient').val(this.currentProduct.ingredient).trigger('change.select2')
      }
    },
    'currentProduct.type' (val, oldVal) {
      if (val) {
        this.type = val
      }
    },
    products () {
      setTimeout(() => {
        this.table = $('#menu_table:not(".dataTable")').DataTable({
          'order': [[ 6, 'desc' ]],
          'language': {
            'decimal': '',
            'emptyTable': 'No data available in table',
            'info': 'С _START_ до _END_ из _TOTAL_ записей',
            'infoEmpty': 'С 0 до 0 из 0 записей',
            'infoFiltered': '(filtered from _MAX_ total entries)',
            'infoPostFix': '',
            'thousands': ',',
            'lengthMenu': 'Выводить по _MENU_',
            'loadingRecords': 'Loading...',
            'processing': 'Processing...',
            'search': 'Искать:',
            'zeroRecords': 'No matching records found',
            'paginate': {
              'first': 'First',
              'last': 'Last',
              'next': 'След',
              'previous': 'Пред'
            },
            'aria': {
              'sortAscending': ': activate to sort column ascending',
              'sortDescending': ': activate to sort column descending'
            }
          }
        })
      }, 300)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/lk/user/restaurant/menu.vue